import config from './config'
export default defineI18nConfig(() => config)
